import React from 'react';
import { inject } from 'mobx-react';
import { useClassName } from 'common/hooks';
import CoverVideo from '../CoverVideo/CoverVideo';
import './park-screen-hero.less';
import GetTickets from '../GetTickets/GetTickets';
import SubNav from '../SubNav/SubNav';
import {
  getContentfulAssetUrlandAlt,
  getContentfulField,
} from 'common/components';

const ParkScreenHero = ({ venue }) => {
  const className = useClassName('ParkScreenHero');
  const openingHoursBanner = getContentfulField(
    venue?.parkScreen?.openingHoursBanner
  );

  const assetEntry = openingHoursBanner?.fields?.asset
    ? getContentfulField(openingHoursBanner.fields.asset)
    : null;

  const mappedOpeningHoursBanner = !openingHoursBanner
    ? null
    : {
        name: getContentfulField(openingHoursBanner?.fields?.name),
        hideLinearGradient: getContentfulField(
          openingHoursBanner?.fields?.hideLinearGradient
        ),
        asset: assetEntry
          ? {
              name: getContentfulField(assetEntry?.fields?.name),
              mobile: assetEntry?.fields?.mobile
                ? getContentfulAssetUrlandAlt(assetEntry.fields.mobile)
                : null,
              tablet: assetEntry?.fields?.tablet
                ? getContentfulAssetUrlandAlt(assetEntry.fields.tablet)
                : null,
              desktop: assetEntry?.fields?.desktop
                ? getContentfulAssetUrlandAlt(assetEntry.fields.desktop)
                : null,
            }
          : null,
      };

  return (
    <div className={className('container')}>
      <SubNav venue={venue} openingHoursBanner={mappedOpeningHoursBanner} />
      <CoverVideo venue={venue} />
      <GetTickets venue={venue} openingHoursBanner={mappedOpeningHoursBanner} />
    </div>
  );
};

export default inject('betaFeatures')(ParkScreenHero);
